import { appConstants } from "../constants";
import { produce } from "immer";

const initialState = {
  landingPages: {},
  loaded: false,
};

const appReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case appConstants.INITIALIZE:
        break;
      case appConstants.RECEIVED_CONFIG:
        if (action && action.config) {
          if (action.config.landingPages) {
            draft.landingPages = action.config.landingPages;
          }
          draft.loaded = true;
        }
        break;
      default:
        break;
    }
  });

export default appReducer;